module.exports = __webpack_public_path__ + "img/logo_ooca.e66c125e.svg";